// src/Pages/ProjectDetail/ProjectDetail.js
import React, { useState } from 'react'; 
import { projectData } from '../../Data/projectData'; 
import Bottom from '../Bottom/Bottom'; 
import './ProjectDetail.css';

// ================= AUTOMATISCHE EXTENSIE-FALLBACK VOOR PUBLIC FOLDER =================
function ImageWithFallback({ projectId, index, projectTitle }) {
  const extensions = ['png', 'jpg', 'jpeg', 'PNG', 'JPG'];
  const [extIndex, setExtIndex] = useState(0);

  const currentSrc = `/images/Showcase/${projectId}/${index}.${extensions[extIndex]}`;

  const handleError = () => {
    if (extIndex < extensions.length - 1) {
      setExtIndex(extIndex + 1); 
    }
  };

  return (
    <div className="gallery-image-wrapper">
      <img 
        src={currentSrc} 
        alt={`${projectTitle} detailed shot ${index}`} 
        onError={handleError}
      />
    </div>
  );
}
// =====================================================================================

export default function ProjectDetail({ projectId = "kiko-de-kikker" }) {
  
  if (!projectData) {
    return <div className="project-error">Database 'projectData' kon niet worden geladen. Check de import!</div>;
  }

  const project = projectData.find(p => p.id === projectId);

  if (!project) {
    return <div className="project-error">Project not found.</div>;
  }

  const hasMetadata = !!project.course;
  const hasExperts = project.experts && (Array.isArray(project.experts) ? project.experts.filter(e => e.trim() !== "").length > 0 : project.experts.trim() !== "");

  const getEmbedUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('/') || url.startsWith('http') && url.endsWith('.mp4')) {
      return url;
    }
    if (url.includes('youtu.be/')) {
      return `https://www.youtube.com/embed/${url.split('youtu.be/')[1].split('?')[0]}`;
    }
    if (url.includes('youtube.com/watch?v=')) {
      return `https://www.youtube.com/embed/${url.split('v=')[1].split('&')[0]}`;
    }
    if (url.includes('youtube.com/embed/')) {
      return url;
    }
    return url; 
  };

  const isYouTube = project.videoUrl && (project.videoUrl.includes('youtube.com') || project.videoUrl.includes('youtu.be'));
  const finalVideoUrl = getEmbedUrl(project.videoUrl);
  const hasValidVideo = project.videoUrl && project.videoUrl.trim() !== "" && !project.videoUrl.includes('overdetop_demo.mp4');

  const imageNumbers = [];
  if (project.imageCount && project.imageCount > 0) {
    for (let i = 1; i <= project.imageCount; i++) {
      imageNumbers.push(i);
    }
  }

  return (
    <div className="project-detail-wrapper">
      <div className="project-detail-container">
        
        {/* ================= MODERNE 2x2 GRID OPZET VINGERT PERFECTE ALIGNMENT OP ================= */}
        <div className="project-main-grid">
          
          {/* KWADRANT 1: BADGE & TITEL */}
          <div className="project-title-area">
            {project.eas && (
              <div className="project-eas-badge-container">
                <img src={project.eas} alt="Expertise Areas" className="project-eas-badge-img" />
              </div>
            )}
            <h1 className="project-main-title">{project.title}</h1>
          </div>

          {/* KWADRANT 2: METADATA ROW */}
          <div className="project-meta-area">
            {hasMetadata && (
              <div className="project-metadata-row">
                <div className="meta-block">
                  <p className="p-blue">Course</p>
                  <p className="meta-value">{project.course}</p>
                </div>
                <div className="meta-block">
                  <p className="p-blue">Grade</p>
                  <p className="meta-value">{project.grade}</p>
                </div>
                {hasExperts && (
                  <div className="meta-block">
                    <p className="p-blue">Experts</p>
                    {Array.isArray(project.experts) ? (
                      project.experts.map((expert, index) => (
                        <p key={index} className="meta-value-item">{expert}</p>
                      ))
                    ) : (
                      <p className="meta-value">{project.experts}</p>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* KWADRANT 3: IN SHORT DESCRIPTION */}
          <div className="project-description-area">
            <h2 className="project-in-short-header">In short</h2>
            <p className="project-explanatory-text">{project.inShort}</p>
          </div>

          {/* KWADRANT 4: VIDEO / IMAGES CONTAINER */}
          <div className="project-media-area">
            <div className="project-media-container">
              {hasValidVideo ? (
                isYouTube ? (
                  <iframe
                    src={finalVideoUrl}
                    title={`${project.title} video`}
                    frameBorder="0"
                    allowFullScreen
                    className="project-media-element"
                  />
                ) : (
                  <video 
                    src={finalVideoUrl} 
                    controls 
                    className="project-media-element"
                    poster={project.placeholderImg}
                  />
                )
              ) : (
                <img 
                  src={project.placeholderImg} 
                  alt={`${project.title} visualization`} 
                  className="project-media-element"
                />
              )}
            </div>
          </div>

        </div>

        {/* ================= LOWER GALLERY SECTIE ================= */}
        {imageNumbers.length > 0 && (
          <div className="project-gallery-section">
            {imageNumbers.map((num) => (
              <ImageWithFallback 
                key={`${project.id}-${num}`} 
                projectId={project.id} 
                index={num} 
                projectTitle={project.title} 
              />
            ))}
          </div>
        )}

      </div>

      <div className="project-detail-bottom-spacer"></div>
      <Bottom />
    </div>
  );
}